export default __webpack_public_path__ + "static/media/gov-am-white.31a7fd7e.svg";